import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../config/environments/environment';
import { Observable } from 'rxjs';
import { Ticket } from '../models';
import { TicketParamsDto, UpdateTicketDto } from '../dtos';

@Injectable()
export class TicketsService {

  private readonly path = 'tickets';

  constructor(
    private readonly http: HttpClient
  ) { }

  findById(id: string): Observable<Ticket> {
    return this.http
      .get<Ticket>(`${environment.api.baseUrl}/${this.path}/${id}`)
      .pipe((response) => response);
  }

  findAll(params: TicketParamsDto) {
    const url = `${environment.api.baseUrl}/${this.path}`;
    
        const httpParams = this.buildHttpParams(params);
        return this.http
          .get<Ticket[]>(url, { params: httpParams })
          .pipe((response) => response);
  }

  update(id: string,update: UpdateTicketDto): Observable<any> {
    return this.http.put(`${environment.api.baseUrl}/${this.path}/${id}`,
      update,
      {}
    );
  }

  private buildHttpParams(params?: TicketParamsDto): HttpParams {
    let httpParams: any = {};

    if(params?.idRoom){
      httpParams.idRoom = params?.idRoom
    }

    if (params?.active) {
      httpParams.active = params?.active;
    }

    return httpParams;
  }
}
